import { Modal, ModalProps, Space } from "antd";
import { ApiService } from "api/api.service";
import { ApplicationDto } from "dtos/application.dto";
import { StrategyResponse } from "dtos/strategy.dto";
import { StrategyPreview } from "components/StrategyPreview";
import { SelectStrategyParams } from "api/strategy.service";

interface PreviewStrategyModalProps extends ModalProps {
  open: boolean;
  isLoading?: boolean;
  appKey: ApplicationDto["app_key"] | undefined;
  selector_key: StrategyResponse["selector_key"] | undefined;
  onCancel: () => unknown;
  onConfirm: (payload: SelectStrategyParams) => unknown;
}

export const PreviewStrategyModal = ({
  open,
  isLoading = false,
  appKey,
  selector_key: slug,
  onCancel,
  onConfirm,
  ...props
}: PreviewStrategyModalProps) => {
  props.okText ||= "Select Strategy";
  props.cancelText ||= "Close Preview";

  const previewStrategy = ApiService.strategy.usePreviewStrategy({
    appKey,
    slug,
  });

  const onOk = () => {
    onConfirm({ appKey, slug });
  };

  return (
    <Modal
      title={
        <Space>
          Preview {previewStrategy.data?.result.strategy.key || "Strategy"}
          {/* <Tag color="geekblue" className="uppercase">
            Beta
            <Tooltip title="Metrics in the overview might not match the ledger distribution">
              <TbInfoCircle />
            </Tooltip>
          </Tag> */}
        </Space>
      }
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      className="min-w-[720px] rounded-xl overflow-hidden"
      classNames={{
        body: "border border-solid border-gray-200 rounded-md shadow",
      }}
      styles={{
        body: {
          maxHeight: "450px",
          overflowY: "auto",
        },
        footer: {
          display: "flex",
        },
      }}
      okButtonProps={{ className: "w-1/2", loading: isLoading }}
      cancelButtonProps={{ className: "w-1/2" }}
      {...props}
    >
      <StrategyPreview loading={previewStrategy.isLoading} {...previewStrategy.data?.result} />
    </Modal>
  );
};
